import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import "../App.css";

/* =======================
   CLIENT PORTAL WITH AI PARSING
======================= */
export default function ClientPortal() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [orders, setOrders] = useState([]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [view, setView] = useState("history");
  const [orderText, setOrderText] = useState("");
  const [form, setForm] = useState({
    recipient_name: "",
    recipient_phone: "",
    package_type: "",
    package_price: "",
    delivery: "",
    
    payment_method: "",
  });
  const [loading, setLoading] = useState(false);
  const fieldLabels = {
  recipient_name: { label: "Destinataire" },
  recipient_phone: { label: "Téléphone du destinataire" },
  package_type: { label: "Type de colis" },
  package_price: { label: "Valeur du colis" },
  delivery: { label: "Adresse de livraison" },
  payment_method: { label: "Mode de paiement" },

  delivery_fee_payer: {
    label: "Frais de livraison payés par",
    values: {
      business: "Le commerçant",
      client: "Le client",
    },
  },
};


  /* ======================
     AUTH
  ====================== */
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) {
        setUser(data.session.user);
        loadProfile(data.session.user.id);
      }
    });
  }, []);

  const login = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) return alert(error.message);

    setUser(data.user);
    loadProfile(data.user.id);
  };

  const logout = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };
  //order code
    const generateOrderCode = () => {
    const ts = Date.now().toString().slice(-6);
    return `A${ts}`;
    
  };

  /* ======================
     PROFILE + ORDERS
  ====================== */
  const loadProfile = async (id) => {
    const { data } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", id)
      .single();
    setProfile(data);
    fetchOrders(id);
  };

  const fetchOrders = async (id) => {
    const { data } = await supabase
      .from("orders")
      .select("*")
      .eq("client_id", id)
      .order("created_at", { ascending: false });
    setOrders(data || []);
  };
  /* ======================
   REALTIME ORDERS UPDATES
====================== */
useEffect(() => {
  if (!user) return;

  const channel = supabase
    .channel("client-orders-realtime")
    .on(
      "postgres_changes",
      { event: "*", schema: "public", table: "orders", filter: `client_id=eq.${user.id}` },
      (payload) => {
        if (payload.eventType === "INSERT") {
          setOrders((prev) => [payload.new, ...prev]);
        } else if (payload.eventType === "UPDATE") {
          setOrders((prev) =>
            prev.map((o) => (o.id === payload.new.id ? payload.new : o))
          );
        } else if (payload.eventType === "DELETE") {
          setOrders((prev) => prev.filter((o) => o.id !== payload.old.id));
        }
      }
    )
    .subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
}, [user]);

  /* ======================
     AI PARSE ORDER USING GEMINI
  ====================== */
  const cleanedText = orderText
  .replace(/\r/g, "\n")           // fix Windows line breaks
  .replace(/\t/g, " ")           // remove tabs
  .replace(/\u00A0/g, " ")       // remove non-breaking spaces
  .replace(/\n+/g, "\n")         // remove extra empty lines
  .trim()
  /* ======================
   AI PARSE ORDER USING GEMINI (FIXED)
===================== */
/* ======================
   AI PARSE ORDER USING GEMINI (FIXED)
===================== */
/* ======================
   AI PARSE ORDER USING GEMINI (FIXED)
===================== */
const parseOrder = async () => {
  if (!orderText.trim()) {
    alert("Veuillez entrer le texte de la commande.");
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(
      "https://generativelanguage.googleapis.com/v1/models/gemini-2.5-flash:generateContent?key=AIzaSyCqCerUXP4j6ZMir_OpecODEZby-qCq5Jo",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                {
                  text: `
Tu es un assistant qui extrait des informations de commandes en français.

Extrais UNIQUEMENT ces champs du texte de commande:
- recipient_name: nom du destinataire
- recipient_phone: téléphone du destinataire  
- package_type: type de colis
- package_price: valeur du colis (nombre uniquement, sans FCFA)
- delivery_address: adresse de livraison
- payment_method: mode de paiement

RÈGLES IMPORTANTES:
1. Réponds UNIQUEMENT avec un objet JSON valide
2. Ne mets AUCUN texte avant ou après le JSON
3. Utilise des guillemets doubles pour les clés et les valeurs
4. Échappe les guillemets doubles dans les valeurs avec \\
5. Pas de markdown, pas de \`\`\`json, pas d'explications

EXEMPLE:
{"recipient_name":"Jean Koné","recipient_phone":"70123456","package_type":"Document","package_price":"5000","delivery_address":"Ouagadougou secteur 4","payment_method":"Om"}

Texte de commande:
${orderText.trim()}

JSON:
`,
                },
              ],
            },
          ],
          generationConfig: { 
            temperature: 0,
            maxOutputTokens: 500
          },
        }),
      }
    );

    const data = await response.json();
    console.log("GEMINI FULL RESPONSE:", JSON.stringify(data, null, 2));

    // Check for API errors
    if (data.error) {
      console.error("API Error:", data.error);
      alert(`Erreur API: ${data.error.message}`);
      setLoading(false);
      return;
    }

    // === CORRECTED CONTENT EXTRACTION ===
    let contentText = "";

    // Extract text from the response
    if (data?.candidates && data.candidates.length > 0) {
      const candidate = data.candidates[0];
      
      // Standard Gemini response structure
      if (candidate?.content?.parts && candidate.content.parts.length > 0) {
        contentText = candidate.content.parts[0].text || "";
      }
      
      // Alternative structure
      if (!contentText && candidate?.text) {
        contentText = candidate.text;
      }
    }

    console.log("EXTRACTED CONTENT TEXT:", contentText);

    if (!contentText) {
      console.error("No content returned by Gemini:", data);
      alert(`Réponse IA vide. Vérifiez le texte de commande.`);
      setLoading(false);
      return;
    }

    // === ADVANCED JSON CLEANING ===
    let cleaned = contentText
      .replace(/\u00A0/g, " ")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .replace(/\t/g, " ")
      .trim();

    // Remove markdown code blocks
    cleaned = cleaned.replace(/```json\s*/g, "");
    cleaned = cleaned.replace(/```\s*/g, "");
    cleaned = cleaned.replace(/`/g, "");
    
    // Remove any text before the first {
    const firstBrace = cleaned.indexOf("{");
    if (firstBrace > 0) {
      cleaned = cleaned.substring(firstBrace);
    }
    
    // Remove any text after the last }
    const lastBrace = cleaned.lastIndexOf("}");
    if (lastBrace > 0 && lastBrace < cleaned.length - 1) {
      cleaned = cleaned.substring(0, lastBrace + 1);
    }
    
    console.log("CLEANED TEXT:", cleaned);

    // === ROBUST JSON PARSING ===
    let parsedJSON = null;
    
    // Try direct parsing first
    try {
      parsedJSON = JSON.parse(cleaned);
    } catch (parseError) {
      console.log("Direct parse failed:", parseError.message);
      
      // Try to fix common JSON issues
      try {
        let fixed = cleaned;
        
        // Fix unquoted keys
        fixed = fixed.replace(/([{,]\s*)(\w+)(\s*:)/g, '$1"$2"$3');
        
        // Fix single quotes
        fixed = fixed.replace(/'/g, '"');
        
        // Remove trailing commas
        fixed = fixed.replace(/,(\s*[}\]])/g, '$1');
        
        // Fix missing commas between items
        fixed = fixed.replace(/}\s*{/g, '},{');
        
        // Fix unterminated strings - add missing quotes
        fixed = fixed.replace(/:\s*([^",\s][^,\n}]*)([,\n}])/g, (match, p1, p2) => {
          if (!p1.startsWith('"')) {
            return `:"${p1.replace(/"/g, '\\"')}"${p2}`;
          }
          return match;
        });
        
        // Fix incomplete strings
        let inString = false;
        let fixedChars = [];
        for (let i = 0; i < fixed.length; i++) {
          const char = fixed[i];
          if (char === '"' && (i === 0 || fixed[i-1] !== '\\')) {
            inString = !inString;
            fixedChars.push(char);
          } else if (char === '\n' && inString) {
            fixedChars.push('\\n');
          } else {
            fixedChars.push(char);
          }
        }
        fixed = fixedChars.join('');
        
        // Ensure string is properly terminated
        if (inString) {
          fixed += '"';
        }
        
        console.log("FIXED JSON:", fixed);
        parsedJSON = JSON.parse(fixed);
      } catch (secondError) {
        console.error("Second parse attempt failed:", secondError.message);
        
        // Last resort: try to extract values with regex
        try {
          const extractValue = (key) => {
            const regex = new RegExp(`"${key}"\\s*:\\s*"?([^",}\\n]+)"?`, 'i');
            const match = cleaned.match(regex);
            return match ? match[1].trim().replace(/^"|"$/g, '') : "";
          };
          
          parsedJSON = {
            recipient_name: extractValue('recipient_name'),
            recipient_phone: extractValue('recipient_phone'),
            package_type: extractValue('package_type'),
            package_price: extractValue('package_price'),
            delivery_address: extractValue('delivery_address'),
            payment_method: extractValue('payment_method')
          };
          
          console.log("Extracted via regex:", parsedJSON);
        } catch (regexError) {
          console.error("Regex extraction failed:", regexError);
          alert(`Impossible d'extraire les données. Réponse reçue: "${cleaned.substring(0, 200)}..."`);
          setLoading(false);
          return;
        }
      }
    }

    if (!parsedJSON) {
      alert("Erreur: Impossible d'extraire les données");
      setLoading(false);
      return;
    }

    console.log("FINAL PARSED JSON:", parsedJSON);

    // === UPDATE FORM ===
    setForm({
      recipient_name: parsedJSON.recipient_name || "",
      recipient_phone: parsedJSON.recipient_phone || "",
      package_type: parsedJSON.package_type || "",
      package_price: parsedJSON.package_price ? String(parsedJSON.package_price).replace(/[^0-9]/g, '') : "",
      delivery: parsedJSON.delivery_address || "",
      payment_method: parsedJSON.payment_method || "",
      delivery_fee_payer: "business",
    });

    setView("recap");
  } catch (err) {
    console.error("FULL ERROR:", err);
    alert("Erreur: " + err.message);
  } finally {
    setLoading(false);
  }
};
  /* ======================
     SUBMIT ORDER
  ====================== */
  const submitOrder = async () => {
 const orderCode = generateOrderCode();
  if (!form) return;

  const { data, error } = await supabase.from("orders").insert({

    client_id: user.id,
    client_name: profile.business_name,
    phone: profile.phone,
    pickup: profile.pickup_address,
    recipient_name: form.recipient_name,
    recipient_phone: form.recipient_phone,
    package_type: form.package_type,
    package_price: form.package_price,
    delivery: form.delivery,
    distance: form.distance,
    payment_method: form.payment_method,
    delivery_fee_payer: form.delivery_fee_payer,
    order_code: orderCode,
    status: "En attente",
  });

  if (error) {
    console.error("INSERT ERROR:", error);
    alert(error.message);
    return;
  }

  setView("history");
  setOrderText(""); 
  fetchOrders(user.id);
};

  /* ======================
     LOGIN SCREEN
  ====================== */
  if (!user) {
    return (
      <div className="admin-container">
        <div className="driver-login">
          <h2>Portail Client</h2>

          <div className="field">
            <label>Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="field">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="login-btn" onClick={login}>
            Connexion
          </button>
        </div>
      </div>
    );
  }

  /* ======================
     PORTAL UI
  ====================== */
  return (
    <div className="admin-page">
      <header className="topbar">
        <h1 className="topbar-title">Watamin • {profile?.business_name}</h1>

        <div>
          <button className="ghost" onClick={() => setView("history")}>
            Historique
          </button>

          <button className="primary" onClick={() => setView("new")}>
            Nouvelle commande
          </button>

          <button className="ghost logout-btn" onClick={logout}>
            Déconnexion
          </button>
        </div>
      </header>

      <main className="admin-content">
        {/* HISTORY */}
        {view === "history" && (
          <div className="admin-section">
            <h2 className="section-title">Historique des commandes</h2>

            <div className="table-wrapper">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Commande</th>
                    <th>Destinataire</th>
                    <th>Telephone</th>
                    <th>Adresse</th>
                    <th>Valeur du colis</th>
                    <th>Prix</th>
                    <th>Statut</th>
                  </tr>
                </thead>

                <tbody>
                  {orders.map((o) => (
                    <tr key={o.id}>
                      <td>{new Date(o.created_at).toLocaleString("fr-FR")}</td>
                      <td>{o.order_code}</td>
                      <td>{o.recipient_name}</td>
                      <td>{o.phone}</td>
                      <td>{o.delivery}</td>
                      <td>{o.package_price} FCFA</td>
                      <td>{o.price} FCFA</td>
                      <td>{o.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* NEW ORDER */}
        {view === "new" && (
          <div className="form-section">
            <h2>Créer une commande</h2>
            <p>Entrez les informations de la commande</p>
            <p>Ex: destinataire, téléphone, type de colis, prix, adresse de livraison, moyen paiement</p>

            <textarea
              rows="6"
              style={{
                width: "100%",
                marginTop: "16px",
                padding: "14px",
                borderRadius: "10px",
                border: "1px solid #ddd",
              }}
              value={orderText}
              onChange={(e) => setOrderText(e.target.value)}
              
            />

            <div style={{ marginTop: "20px" }}>
  <label style={{ fontWeight: "600", display: "block", marginBottom: "8px" }}>
    Les frais de livraison sont payés par :
  </label>

  <div className="toggle-group">
    <button
      className={form.delivery_fee_payer === "business" ? "toggle active" : "toggle"}
      onClick={() => setForm({ ...form, delivery_fee_payer: "business" })}
    >
      Le commerçant
    </button>

    <button
      className={form.delivery_fee_payer === "client" ? "toggle active" : "toggle"}
      onClick={() => setForm({ ...form, delivery_fee_payer: "client" })}
    >
      Le client
    </button>
  </div>
</div>

<div className="action-bar">
  <button
    className="primary"
    onClick={parseOrder}
    disabled={loading}
  >
    {loading ? "Chargement..." : "Confirmer"}
  </button>
</div>
          </div>
        )}

        {/* RECAP */}
    
     {view === "recap" && (
  <div className="form-section">
    <h2>Récapitulatif</h2>
    

    <div className="summary-grid">
      {Object.entries(form).map(([key, value]) => {

  const label = fieldLabels[key]?.label || key.replaceAll("_", " ");
  const displayValue = fieldLabels[key]?.values?.[value] || value;

  return (
    <div className="summary-item" key={key}>
      <label className="summary-label">
        {label}
      </label>

      {key === "delivery_fee_payer" ? (
        <strong>{displayValue}</strong>
      ) : (
        <input
          className="summary-input"
          value={value}
          onChange={(e) =>
            setForm({ ...form, [key]: e.target.value })
          }
        />
      )}
    </div>
  );
})}
    </div>

    <div className="action-bar">
      <button className="ghost" onClick={() => setView("new")}>
        Modifier
      </button>

      <button className="primary" onClick={submitOrder}>
        Confirmer la commande
      </button>
    </div>
  </div>
)}
      </main>
    </div>
  );
}